package one.healthium.profile.navigation.settings

import com.arkivanov.decompose.ComponentContext

class DefaultProfileSettingsComponent(
    componentContext: ComponentContext,
    private val onNameClicked: () -> Unit,
    private val onAgeClicked: () -> Unit,
    private val onHeightClicked: () -> Unit,
    private val onInitialWeightClicked: () -> Unit,
    private val onTargetWeightClicked: () -> Unit,
    private val onContactUsClicked: suspend () -> Unit,
    private val onSettingsMenuClicked: (menuId: String, title: String) -> Unit,
    private val onMealPlanClicked: () -> Unit,
    private val onHealthKitClicked: () -> Unit,
    private val onBackClicked: () -> Unit,
) : ProfileSettingsComponent, ComponentContext by componentContext {
    override fun onNameClicked() {
        onNameClicked.invoke()
    }

    override fun onAgeClicked() {
        onAgeClicked.invoke()
    }

    override fun onHeightClicked() {
        onHeightClicked.invoke()
    }

    override fun onInitialWeightClicked() {
        onInitialWeightClicked.invoke()
    }

    override fun onTargetWeightClicked() {
        onTargetWeightClicked.invoke()
    }

    override suspend fun onContactUsClicked() {
        onContactUsClicked.invoke()
    }

    override fun onSettingsMenuClicked(menuId: String, title: String) {
        onSettingsMenuClicked.invoke(menuId, title)
    }

    override fun onMealPlanClicked() {
        onMealPlanClicked.invoke()
    }

    override fun onBackClicked() {
        onBackClicked.invoke()
    }

    override fun onHealthKitClicked() {
        onHealthKitClicked.invoke()
    }
}
